export default "__VITE_ASSET__Ap9CMYYj__"